import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getRouteStationsPrices } from '../operations/getRouteStationsPrices';

import { STATUS_LOADING } from 'common/constants';

export const setRouteStationsPrices = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getRouteStationsPrices.pending, (state) => {
    state.routeStationsPrices.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getRouteStationsPrices.fulfilled, (state, { payload }) => {
    state.routeStationsPrices.loadingStatus = STATUS_LOADING.done;
    state.routeStationsPrices.data = payload?.sort((firstItem, secondItem) => (
      firstItem.stationInternalId > secondItem.stationInternalId ? 1 : -1
    ));
  })
  .addCase(getRouteStationsPrices.rejected, (state) => {
    state.routeStationsPrices.loadingStatus = STATUS_LOADING.error;
  });